import { createReducer, on } from '@ngrx/store';
import * as CompetitionActions from '../actions/competitions.actions';

export interface State {
    competitions: any[]; 
    errorMessage: string | null;
    isLoading: boolean;
}
export const initialState: State = {
    competitions: [],
    errorMessage: null,
    isLoading: false
};
export const competitionsReducer = createReducer(
    initialState,

    on(CompetitionActions.loadCompetitions, (state) => ({
        ...state,
        isLoading: true,
        errorMessage: null
    })),

    on(CompetitionActions.loadCompetitionsSuccess, (state, { competitions }) => ({
        ...state,
        competitions: competitions,
        isLoading: false,
        errorMessage: null
    })),

    on(CompetitionActions.loadCompetitionsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        errorMessage: error
    }))
);